import { FC } from 'react'

import { Box, Skeleton } from '@mui/material'

import { SectionCard } from '../SectionCard/SectionCard'

/**
 * Body placeholder for the Compare page (`UAInsightsComparePage`). Renders a
 * layout-matched skeleton of the Overview tab (the default landing tab): the
 * four-card KPI strip, the Monthly Insight card and the Motivations / Story
 * Patterns / Creative Tags section cards — so the user sees the intended
 * structure while data loads. The Compare page's sticky header owns the tab
 * bar, so this skeleton is body-only.
 */
export const CompareResultSkeleton: FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    {/* KPI strip — four hero stat cards. */}
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' }, gap: 2 }}>
      {[0, 1, 2, 3].map((i) => (
        <Skeleton key={i} variant="rounded" height={92} sx={{ borderRadius: 1 }} />
      ))}
    </Box>
    {/* Monthly Insight card. */}
    <Skeleton variant="rounded" height={104} sx={{ borderRadius: 1 }} />
    {/* Motivations / Story Patterns / Creative Tags section cards. */}
    {[0, 1, 2].map((i) => (
      <SectionCard key={i} title={<Skeleton variant="text" width={180} height={24} />}>
        <Skeleton variant="rounded" height={120} sx={{ borderRadius: 1 }} />
      </SectionCard>
    ))}
  </Box>
)
